export const TAGLINE_TEXT = 'A gestão completa que o seu estabelecimento precisa.';
export const WELCOME_TEXT = 'Bem-vindo de volta!';
export const CREDENTIALS_TEXT = 'Entre com suas credenciais para acessar o sistema';
export const EMAIL_LABEL = 'Usuário ou e-mail';
export const EMAIL_PLACEHOLDER = 'usuário ou e-mail';
export const PASSWORD_LABEL = 'Senha';
export const PASSWORD_PLACEHOLDER = 'Sua senha';
export const REMEMBER_ME_TEXT = 'Lembrar de mim';
export const FORGOT_PASSWORD_TEXT = 'Esqueci minha senha';
export const LOGIN_BUTTON_TEXT = 'Entrar no sistema';
export const DIVIDER_TEXT = 'ou continue com';
export const GOOGLE_BUTTON_TEXT = 'Entrar com Google';
export const SECURITY_TEXT = 'Seus dados estão protegidos com segurança';
export const FOOTER_TEXT = '© 2026 Weper Solutions. Todos os direitos reservados.';
export const LOGIN_ERROR_TEXT = 'E-mail ou senha inválidos.';
export const ASIDE_CARD_TITLE = 'Gestão inteligente';
export const ASIDE_CARD_DESCRIPTION =
  'Controle pedidos, equipe, cozinha e o painel da operação em um só lugar.';
export const ASIDE_METRIC_CONTROL = 'Mais controle';
export const ASIDE_METRIC_SALES = 'Mais vendas';
export const ASIDE_METRIC_CLIENTS = 'Mais clientes';
export const SUPPORT_TITLE = 'Precisa de ajuda?';
export const SUPPORT_SUBTITLE = 'Fale com nosso suporte';

/** Chave localStorage só para e-mail (nunca senha). */
export const REMEMBER_EMAIL_KEY = 'weper.login.rememberEmail';

/**
 * OAuth Google ainda não está integrado.
 * O botão é apenas visual enquanto esta flag for false.
 */
export const GOOGLE_OAUTH_ENABLED = false;
